import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getConfig } from "../../../../utils";

export const studentRegistration = createAsyncThunk('studentRegistration', async ({ id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: getConfig.API_URL + `student_registration/${id}`,
            headers: { "Accept": "application/json" }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const studentRegistrationSlice = createSlice({
    name: 'studentRegistration',
    initialState: {
        data: '',
    },
    extraReducers: (builder) => {
        builder.addCase(studentRegistration.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else {
                state.data = '';
            }
        });
        builder.addCase(studentRegistration.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default studentRegistrationSlice.reducer;
